module.exports = __webpack_public_path__ + "img/doc.8d23321b.svg";